import {isNullOrUndefined} from "../../../services/Validator";

export default function AuthenticationContentLayout({children}) {
    // Used in AuthenticationScreen to frame
    // screen content

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"bg-backgroundLight2 w-full h-full flex justify-center items-center"}>
            {children}
        </div>
    );
}